const themes = {}
const themesConfigurations = require.context('../themes', true, /theme.js$/)

themesConfigurations.keys().forEach(key => {
  const theme = themesConfigurations(key).default
  const themeName = key.split('/')[1].split('.theme.js')[0]
  themes[themeName] = theme
})

const changeTheme = (themeName) => {
  const vuetify = require('@/plugins/vuetify').default

  if(!vuetify){
    return
  }

  if(!themeName){
    return
  }

  const themeKey = themeName.toLowerCase();
  const themeConfiguration = themes[themeKey]

  if(themeConfiguration){
    const { colors, icons } = themeConfiguration

    Object.keys(colors).forEach(key => {
      vuetify.framework.theme.themes.light[key] = colors[key]
      vuetify.userPreset.theme.themes.light[key] = colors[key]
    })

    Object.keys(icons).forEach(key => {
      vuetify.framework.icons.values[key] = icons[key]
      vuetify.userPreset.icons.values[key] = icons[key]
    })
  }
}

export {themes, changeTheme};
